import {HttpClientModule, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './layout/layout.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import Aura from '@primeng/themes/aura';
import { AppComponent } from './app.component';
import { CarouselModule } from 'primeng/carousel';
import { MuralDigitalComponent } from './mural-digital/mural-digital.component';
import { SharedModule } from './shared/shared.module';
import { ComissaoGamsComponent } from './paginas/comissao-gams/comissao-gams.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ComissaoGamsModule } from './paginas/comissao-gams/comissao-gams.module';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import MyPreset from "./mypreset"; // Importação correta

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    MuralDigitalComponent,
    ComissaoGamsComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    LayoutModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CarouselModule,
    FontAwesomeModule,
    TranslateModule.forRoot({ defaultLanguage: 'pt-BR' }),
    SharedModule,
    ProgressSpinnerModule,
    ComissaoGamsModule,
    ToastModule
  ],
  providers: [
    MessageService,
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    provideAnimationsAsync(),

    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: 'none'
        }
      },
      ripple: true,

      translation: {
        firstDayOfWeek: 0,
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qi', 'Se', 'Sa'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'De'],
        today: 'Hoje',
        clear: 'Limpar',
        dateFormat: 'dd/mm/yy',
        weekHeader: 'Sem',
        chooseMonth: 'Selecionar Mês',
        chooseYear: 'Selecionar Ano',
        chooseDate: 'Escolha a Data',
        prevYear: 'Ano anterior',
        nextYear: 'Próximo ano',
        prevMonth: 'Mês Anterior',
        nextMonth: 'Próximo mês',
        prevDecade: 'Década Anterior',
        nextDecade: 'Próxima Década',
        prevHour: 'Hora Anterior',
        nextHour: 'Próxima Hora',
        prevMinute: 'Minuto Anterior',
        nextMinute: 'Próximo Minuto',
        prevSecond: 'Segundo Anterior',
        nextSecond: 'Próximo Segundo',
        am: 'AM',
        pm: 'PM',
        cancel: 'Cancelar',
        apply: 'Aplicar',

// TABLE / FILTERING
        startsWith: 'Começa com',
        contains: 'Contém',
        notContains: 'Não contém',
        endsWith: 'Termina com',
        equals: 'Igual',
        notEquals: 'Diferente',
        noFilter: 'Sem filtro',

        // 👇 CHAVES ADICIONADAS PARA FILTROS AVANÇADOS (TABELAS)
        matchAll: 'Corresponder a Todos',
        matchAny: 'Corresponder a Qualquer',
        addRule: 'Adicionar Regra',
        removeRule: 'Remover Regra',


        // DIALOG / CONFIRMATION
        // 👇 CHAVES ADICIONADAS PARA DIÁLOGOS DE CONFIRMAÇÃO
        reject: 'Não',
        accept: 'Sim',

        // FILE UPLOAD
        // 👇 CHAVES ADICIONADAS PARA UPLOAD DE ARQUIVOS
        upload: 'Enviar',
        choose: 'Escolher',

        aria: {
          trueLabel: 'Verdadeiro',
          falseLabel: 'Falso',
          nullLabel: 'Não selecionado',
          pageLabel: '',
          firstPageLabel: 'Primeira página',
          lastPageLabel: 'Última página',
          nextPageLabel: 'Próxima página',
          prevPageLabel: 'Página anterior',
          rowsPerPageLabel: 'Linhas por página',
          jumpToPageDropdownLabel: 'Pular para página',
          jumpToPageInputLabel: 'Pular para página',
          close: 'Fechar',
          slideNumber: 'Slide {slideNumber}',
          // Outras chaves ARIA podem ser adicionadas conforme a necessidade
        }
      }
    }),

    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
